import {
  Buff_fatRate,
  Buff_snfRate,
  Cow_fatRate,
  Cow_snfRate,
  Buff_matrix,
  Cow_matrix,
} from "./Matrix";

// A blank fat or snf on a custom entry is a wildcard (matches any value).
// null rather than 0, so "not specified" stays distinguishable from a real 0.
const num = (v) =>
  v === null || v === undefined || v === "" ? null : parseFloat(v);

// Custom chart lookup, most specific first: exact (fat+snf) → fat-only →
// snf-only. Fat outranks snf when a fat-only and an snf-only rule both match.
// Mirrors findCustomRate in the server's bulk-upload.service.js — keep in step.
export function findCustomRate(customChart, type, fatNum, snfNum) {
  const rules = customChart.filter((r) => r.type === type);

  const exact = rules.find(
    (r) => num(r.fat) === fatNum && num(r.snf) === snfNum,
  );
  if (exact) return parseFloat(exact.rate);

  const fatOnly = rules.find(
    (r) => num(r.snf) === null && num(r.fat) === fatNum,
  );
  if (fatOnly) return parseFloat(fatOnly.rate);

  const snfOnly = rules.find(
    (r) => num(r.fat) === null && num(r.snf) === snfNum,
  );
  if (snfOnly) return parseFloat(snfOnly.rate);

  return null;
}

// customChart is the per-dairy array of { type, fat, snf, rate } loaded from
// admin_users.custom_rate_chart. Only consulted when the standard matrix lookup
// misses, so standard entries are completely unaffected.
export function calculateMilkValues({ qty, fat, snf, type = "cow", customChart = [] }) {
  const qtyNum = parseFloat(qty);
  const fatNum = parseFloat(fat);
  const snfNum = parseFloat(snf);

  const isBuffalo = type === "buffalo";

  // Reject unusable input before any lookup. A wildcard custom rule ignores one
  // field, so without this a typo there (44 for 4.4) would silently get priced
  // by the wildcard instead of erroring.
  if (![qtyNum, fatNum, snfNum].every((n) => Number.isFinite(n) && n > 0)) {
    return {
      error: true,
      message: isBuffalo
        ? "Invalid Buffalow fat or snf value"
        : "Invalid Cow fat or snf value",
    };
  }

  const fatRates = isBuffalo ? Buff_fatRate : Cow_fatRate;
  const snfRates = isBuffalo ? Buff_snfRate : Cow_snfRate;
  const matrix = isBuffalo ? Buff_matrix : Cow_matrix;

  const i = fatRates.indexOf(fatNum);
  const j = snfRates.indexOf(snfNum);

  let rate;
  if (i !== -1 && j !== -1) {
    rate = matrix[i][j]; // matrix cell IS the final rate (Kolhapur union chart revision)
  } else {
    rate = findCustomRate(customChart, type, fatNum, snfNum);
    if (rate === null) {
      return {
        error: true,
        message: isBuffalo
          ? "Invalid Buffalow fat or snf value"
          : "Invalid Cow fat or snf value",
      };
    }
  }

  const t_rate = Math.round(parseFloat(rate) * qtyNum * 100) / 100; // nearest paisa, matches V1
  return { error: false, rate, t_rate };
}
